import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';

const UserProfile = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userGroups, setUserGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGroups = async () => {
      if (authState?.isAuthenticated) {
        try {
          const user = await oktaAuth.getUser();
          console.log('User from API:', user);
          setUserGroups(user.groups || []);
        } catch (error) {
          console.error('Error fetching user:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchGroups();
  }, [authState, oktaAuth]);

  // Check for simple auth (demouser or manager login)
  const simpleAuth = sessionStorage.getItem('simpleAuth');
  const isAdminView = sessionStorage.getItem('isAdminView') === 'true';
  const managerInfo = sessionStorage.getItem('managerInfo');
  
  // Debug logging
  console.log('=== USER PROFILE DEBUG ===');
  console.log('simpleAuth:', simpleAuth);
  console.log('isAdminView:', isAdminView);
  console.log('managerInfo:', managerInfo);
  
  // If using simple auth, display that info
  if (simpleAuth && !authState?.isAuthenticated) {
    let userInfo = {};
    let groups = [];
    
    if (isAdminView) {
      console.log('Showing Admin User');
      userInfo = {
        name: 'Admin User',
        email: 'admin@ryder.com'
      };
      groups = ['Admin', 'Full Access'];
    } else if (managerInfo) {
      console.log('Showing Manager Info');
      const parsedInfo = JSON.parse(managerInfo);
      console.log('Parsed Manager Info:', parsedInfo);
      userInfo = {
        name: parsedInfo.name,
        email: parsedInfo.email || 'manager@ryder.com',
        title: parsedInfo.title,
        department: parsedInfo.department
      };
      groups = ['Manager'];
    } else {
      console.log('No admin or manager info found');
    }
    
    return (
      <div style={{ 
        marginTop: '0',
        marginBottom: '24px',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0'
      }}>
        <h2 style={{ 
          margin: '0 0 16px 0', 
          fontSize: '18px', 
          color: '#333',
          fontWeight: '600'
        }}>
          Welcome! 
        </h2>
        
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            backgroundColor: '#6c5ce7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '18px',
            fontWeight: 'bold',
            marginRight: '16px'
          }}>
            {userInfo?.name?.charAt(0)?.toUpperCase() || 'M'}
          </div>
          
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: '0 0 4px 0', fontSize: '16px', color: '#333' }}>
              {userInfo?.name}
            </h3>
            <p style={{ margin: '0 0 4px 0', color: '#666', fontSize: '14px' }}>
              {userInfo?.email}
            </p>
            {userInfo?.title && (
              <p style={{ margin: '0 0 4px 0', color: '#666', fontSize: '14px' }}>
                <span style={{ fontWeight: '500' }}>Title: </span>{userInfo.title}
              </p>
            )}
            <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>
              <span style={{ fontWeight: '500' }}>Groups: </span>
              {groups.join(', ')}
            </p>
          </div>
          
          <div style={{
            backgroundColor: '#00b894',
            color: 'white',
            padding: '4px 12px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '500'
          }}>
            Active
          </div>
        </div>
      </div>
    );
  }

  if (!authState?.isAuthenticated) return null;

  const userInfo = authState.idToken?.claims;
  
  return (
    <div style={{ 
      marginTop: '0',
      marginBottom: '24px',
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e0e0'
    }}>
      <h2 style={{ 
        margin: '0 0 16px 0', 
        fontSize: '18px', 
        color: '#333',
        fontWeight: '600'
      }}>
        Welcome! 
      </h2>
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* Avatar Circle */}
        <div style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          backgroundColor: '#6c5ce7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '18px',
          fontWeight: 'bold',
          marginRight: '16px'
        }}>
          {userInfo?.name?.charAt(0)?.toUpperCase() || 'U'}
        </div>
        
        <div style={{ flex: 1 }}>
          <h3 style={{ margin: '0 0 4px 0', fontSize: '16px', color: '#333' }}>
            {userInfo?.name}
          </h3>
          <p style={{ margin: '0 0 4px 0', color: '#666', fontSize: '14px' }}>
            {userInfo?.email}
          </p>
          <p style={{ margin: '0', color: '#666', fontSize: '14px' }}>
            <span style={{ fontWeight: '500' }}>Groups: </span>
            {loading ? 'Loading...' : (userGroups.length > 0 ? userGroups.join(', ') : 'None')}
          </p>
        </div>
        
        {/* Status Badge */}
        <div style={{
          backgroundColor: '#00b894',
          color: 'white',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500'
        }}>
          Active
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
